// assets
import { Code1, I24Support } from "iconsax-react";
// material-ui
import { List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

// import { useState } from "react";

// ==============================|| HEADER PROFILE - SETTING TAB ||============================== //

const SettingTab = () => {
  // const [selectedIndex, setSelectedIndex] = useState(0);
  // const handleListItemClick = (event, index) => {
  //   setSelectedIndex(index);
  // };

  return (
    <List component="nav" sx={{ p: 0, "& .MuiListItemIcon-root": { minWidth: 32 } }}>
      {/* <ListItemButton
        // selected={selectedIndex === 0}
        // onClick={(event) => handleListItemClick(event, 0)}
        component={Link}
        to="/user/account-settings/account"
      >
        <ListItemIcon>
          <Profile variant="Bulk" size={18} />
        </ListItemIcon>
        <ListItemText primary="Account Settings" />
      </ListItemButton> */}

      <ListItemButton>
        <ListItemIcon>
          <Code1 variant="Bulk" size={18} />
        </ListItemIcon>
        <ListItemText
          primary="API Docs"
          onClick={() => {
            {
              window.open("https://frogdocs.wigal.com.gh", "_blank");
            }
          }}
        />
      </ListItemButton>
      <ListItemButton>
        <ListItemIcon>
          <I24Support variant="Bulk" size={18} />
        </ListItemIcon>
        <ListItemText
          primary="Support"
          onClick={() => {
            {
              window.open("https://support.wigal.com.gh/", "_blank");
            }
          }}
        />
      </ListItemButton>
    </List>
  );
};

export default SettingTab;
